export default function (basicType, definedType) {
  switch (basicType) {
    case "systemtask":
    case "comment":
    case "log":
    case "email":
    case "campaign":
    case "transaction":
    case "submission":
    case "campaign":
    case "notification":
    case "event":
    case "checkin":
    case "runsheet":
      return true;
    default:
      switch (definedType) {
        case "photo":
          return true;
      }
      break;
  }
}
